(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  function updateQty(index, change) {
    const inputs = document.querySelectorAll('input[name="updates[]"]');
    const input = inputs[index];
    const newValue = parseInt(input.value) + change;
    if (newValue >= 0) {
      input.value = newValue;
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (form) {
      const updateBtn = form.querySelector('button[name="update"]');
      if (updateBtn) {
        updateBtn.addEventListener('click', function(e) {
          e.preventDefault();
          form.submit();
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-age-verifier"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var key = 'tw_age_verified';
    if (document.cookie.indexOf(key + '=1') !== -1) return;
    var el = document.querySelector('[data-tw-age-verifier]');
    if (!el) return;
    el.classList.remove('tw-hidden');
    el.setAttribute('aria-hidden', 'false');
    el.querySelector('[data-tw-age-approve]') && el.querySelector('[data-tw-age-approve]').addEventListener('click', function() {
      document.cookie = key + '=1; path=/; max-age=31536000';
      el.classList.add('tw-hidden');
      el.setAttribute('aria-hidden', 'true');
    });
    el.querySelector('[data-tw-age-decline]') && el.querySelector('[data-tw-age-decline]').addEventListener('click', function() {
      el.querySelector('.tw-age-verifier__content').classList.add('tw-hidden');
      el.querySelector('.tw-age-verifier__decline').classList.remove('tw-hidden');
    });
    el.querySelector('[data-tw-age-return]') && el.querySelector('[data-tw-age-return]').addEventListener('click', function() {
      el.querySelector('.tw-age-verifier__decline').classList.add('tw-hidden');
      el.querySelector('.tw-age-verifier__content').classList.remove('tw-hidden');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.cart-upsell--fetch').forEach(function(el) {
      if (!el.dataset.url) return;
      var track = el.querySelector('[data-upsell-track]');
      if (!track) return;
      fetch(el.dataset.url)
        .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function(html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var sectionId = (el.dataset.sectionId || 'tw-cart-upsell').replace(/\W/g, '-');
          var remote = wrap.querySelector('#shopify-section-' + sectionId + ' [data-upsell-track]');
          if (!remote) remote = wrap.querySelector('[data-upsell-track]');
          if (remote && remote.children.length > 0) {
            track.innerHTML = remote.innerHTML;
          } else {
            el.style.display = 'none';
          }
        })
        .catch(function() { el.style.display = 'none'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-collection-grid"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const swiperEl = document.querySelector('[data-cg-swiper]');
      if (!swiperEl) return;
      const root = swiperEl.closest('section[data-section-id]');
      if (!root) return;
      const SECTION_ID = root.getAttribute('data-section-id');

      const toBool = (v) => String(v) === 'true' || String(v) === '1';

      const init = () => {
        if (!window.Swiper) return false;

        const prev = swiperEl.querySelector('[data-cg-prev]');
        const next = swiperEl.querySelector('[data-cg-next]');
        const pagination = swiperEl.querySelector('[data-cg-pagination]');

        const spvM = parseFloat(swiperEl.getAttribute('data-spv-m') || 1);
        const spvT = parseFloat(swiperEl.getAttribute('data-spv-t') || 2);
        const spvD = parseFloat(swiperEl.getAttribute('data-spv-d') || 3);
        const gap = Number(swiperEl.getAttribute('data-gap') || 16);

        const loop = toBool(swiperEl.getAttribute('data-loop'));
        const autoplayEnabled = toBool(swiperEl.getAttribute('data-autoplay'));
        const speed = Number(swiperEl.getAttribute('data-speed') || 3000);
        const effect = swiperEl.getAttribute('data-effect') || 'slide';
        const speedTransition = Number(swiperEl.getAttribute('data-speed-transition') || 300);
        const centered = toBool(swiperEl.getAttribute('data-centered'));
        const grab = toBool(swiperEl.getAttribute('data-grab'));
        const freeMode = toBool(swiperEl.getAttribute('data-free-mode'));
        const pauseOnHover = toBool(swiperEl.getAttribute('data-pause-on-hover'));

        if (swiperEl.__twSwiper) {
          try { swiperEl.__twSwiper.destroy(true, true); } catch(e) {}
          swiperEl.__twSwiper = null;
        }

        const cfg = {
          slidesPerView: spvM,
          spaceBetween: gap,
          watchOverflow: true,
          speed: speedTransition,
          effect: effect,
          centeredSlides: centered,
          grabCursor: grab,
          freeMode: freeMode,
          loop: loop,
          breakpoints: {
            768: { slidesPerView: spvT, centeredSlides: centered },
            1024: { slidesPerView: spvD, centeredSlides: centered }
          }
        };

        // Navigation
        if (prev && next) {
          cfg.navigation = { prevEl: prev, nextEl: next };
        }

        // Pagination
        if (pagination) {
          cfg.pagination = {
            el: pagination,
            clickable: true,
            dynamicBullets: false
          };
        }

        // Autoplay
        if (autoplayEnabled) {
          cfg.autoplay = {
            delay: speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover
          };
        }

        // Effect-specific settings
        if (effect === 'fade') {
          cfg.fadeEffect = { crossFade: true };
        } else if (effect === 'cube') {
          cfg.cubeEffect = {
            shadow: true,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94
          };
        } else if (effect === 'coverflow') {
          cfg.coverflowEffect = {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          };
        } else if (effect === 'flip') {
          cfg.flipEffect = {
            slideShadows: true,
            limitRotation: true
          };
        }

        swiperEl.__twSwiper = new window.Swiper(swiperEl, cfg);
        return true;
      };

      let tries = 0;
      const t = setInterval(() => {
        tries += 1;
        if (init() || tries > 40) clearInterval(t);
      }, 100);

      document.addEventListener('shopify:section:load', (e) => {
        if (e?.detail?.sectionId != SECTION_ID) return;
        setTimeout(init, 80);
      });
      document.addEventListener('shopify:section:select', (e) => {
        if (e?.detail?.sectionId != SECTION_ID) return;
        setTimeout(init, 80);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-libro-reclamaciones"] && !Shopify.designMode) return;
  try {
    
  function initLibroReclamacionesDate() {
    document.querySelectorAll('.lr-current-date').forEach(function (el) {
      var loc = el.getAttribute('data-locale') || 'es-ES';
      var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      var today = new Date().toLocaleDateString(loc, dateOptions);
      today = today.charAt(0).toUpperCase() + today.slice(1);
      today = today.replace(/,/g, '');
      el.textContent = today;
    });
  }
  document.addEventListener('DOMContentLoaded', initLibroReclamacionesDate);
  document.addEventListener('shopify:section:load', initLibroReclamacionesDate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initArticleSwiper(root) {
      if (!root) return;
      var el = root.querySelector('[data-tw-article-swiper]');
      if (!el || typeof window.Swiper === 'undefined') return;
      if (el._twArticleSwiper) {
        try {
          el._twArticleSwiper.destroy(true, true);
        } catch (e) {}
        el._twArticleSwiper = null;
      }
      var prev = root.querySelector('[data-tw-article-prev]');
      var next = root.querySelector('[data-tw-article-next]');
      var pagination = root.querySelector('[data-tw-article-pagination]');
      var cfg = {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 24 }
        }
      };
      if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
      if (pagination) cfg.pagination = { el: pagination, clickable: true };
      el._twArticleSwiper = new window.Swiper(el, cfg);
      [80, 250, 500].forEach(function (ms) {
        setTimeout(function () {
          try {
            if (el._twArticleSwiper) el._twArticleSwiper.update();
          } catch (e) {}
        }, ms);
      });
    }
    function bootAll() {
      document.querySelectorAll('[data-tw-article-root]').forEach(function (root) {
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          if (typeof window.Swiper !== 'undefined') {
            initArticleSwiper(root);
            clearInterval(timer);
          } else if (tries > 50) clearInterval(timer);
        }, 100);
      });
    }
    function bootOne(sectionId) {
      var root = document.querySelector('[data-tw-article-root="' + sectionId + '"]');
      if (!root) return;
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (typeof window.Swiper !== 'undefined') {
          initArticleSwiper(root);
          clearInterval(timer);
        } else if (tries > 50) clearInterval(timer);
      }, 100);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      setTimeout(function () {
        bootOne(String(e.detail.sectionId));
      }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__twMainCollectionToolbar) return;
    window.__twMainCollectionToolbar = true;

    function collectionRoot(el) {
      return el && el.closest ? el.closest('[data-tw-collection-root]') : null;
    }

    function hasOpenDrawer() {
      return !!document.querySelector('[data-tw-sidebar-overlay].is-open:not(.tw-pointer-events-none), [data-tw-sidebar-overlay]:not(.tw-pointer-events-none)');
    }

    function syncBodyScroll() {
      var open = hasOpenDrawer();
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (document.body) {
        document.body.classList.toggle('tw-filter-drawer-open', open);
      }
    }

    function openDrawer(root) {
      var overlay = root.querySelector('[data-tw-sidebar-overlay]');
      var panel = root.querySelector('[data-tw-drawer-panel]');
      var btn = root.querySelector('[data-tw-sidebar-open]');
      if (overlay) {
        overlay.classList.add('is-open');
        overlay.classList.remove('tw-pointer-events-none', 'tw-opacity-0');
        overlay.setAttribute('aria-hidden', 'false');
      }
      if (panel) {
        panel.classList.add('is-open');
        panel.classList.remove('-tw-translate-x-full');
      }
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (document.body) document.body.classList.add('tw-filter-drawer-open');
      syncBodyScroll();
    }

    function closeDrawer(root) {
      var overlay = root.querySelector('[data-tw-sidebar-overlay]');
      var panel = root.querySelector('[data-tw-drawer-panel]');
      var btn = root.querySelector('[data-tw-sidebar-open]');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.classList.add('tw-pointer-events-none', 'tw-opacity-0');
        overlay.setAttribute('aria-hidden', 'true');
      }
      if (panel) {
        panel.classList.remove('is-open');
        panel.classList.add('-tw-translate-x-full');
      }
      if (btn) btn.setAttribute('aria-expanded', 'false');
      syncBodyScroll();
    }

    function twClampGridCols(n) {
      n = parseInt(n, 10);
      if (!isFinite(n)) return 4;
      return Math.min(4, Math.max(2, n));
    }

    function twDefaultGridCols(root) {
      return String(twClampGridCols(root.getAttribute('data-cols-desktop-default')));
    }

    function twNormalizeCollectionView(saved, root) {
      if (saved === 'list') return 'list';
      if (saved === '2' || saved === '3' || saved === '4') return saved;
      if (saved === 'grid') return twDefaultGridCols(root);
      return null;
    }

    function twSyncCollectionViewButtons(root, mode) {
      var group = root.querySelector('.tw-collection-toolbar__views');
      if (!group) return;
      group.querySelectorAll('[data-tw-view]').forEach(function(b) {
        var v = b.getAttribute('data-tw-view');
        var on = v === 'list' ? mode === 'list' : mode !== 'list' && v === 'grid-' + mode;
        b.classList.toggle('tw-collection-view-btn--active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function twApplyCollectionView(root, mode) {
      if (!root || !mode) return;
      var storageKey = 'tw-collection-view-' + root.getAttribute('data-section-id');
      if (mode === 'list') {
        root.classList.add('tw-main-collection--list');
        root.style.removeProperty('--mcp-cols-m');
        root.style.removeProperty('--mcp-cols-t');
        root.style.removeProperty('--mcp-cols-d');
      } else {
        root.classList.remove('tw-main-collection--list');
        var n = String(twClampGridCols(mode));
        root.style.setProperty('--mcp-cols-m', n);
        root.style.setProperty('--mcp-cols-t', n);
        root.style.setProperty('--mcp-cols-d', n);
        mode = n;
      }
      try {
        sessionStorage.setItem(storageKey, mode === 'list' ? 'list' : mode);
      } catch (err) {}
      twSyncCollectionViewButtons(root, mode);
    }

    document.addEventListener('click', function(e) {
      var t = e.target;
      if (t.closest && t.closest('[data-tw-sidebar-open]')) {
        var openBtn = t.closest('[data-tw-sidebar-open]');
        var root = collectionRoot(openBtn);
        if (root) {
          e.preventDefault();
          openDrawer(root);
        }
        return;
      }
      if (t.closest && t.closest('[data-tw-sidebar-close]')) {
        var c = t.closest('[data-tw-sidebar-close]');
        var rootC = collectionRoot(c);
        if (rootC) {
          e.preventDefault();
          closeDrawer(rootC);
        }
        return;
      }
      if (t.closest && t.closest('[data-tw-sidebar-overlay]')) {
        var ov = t.closest('[data-tw-sidebar-overlay]');
        if (ov && !ov.classList.contains('tw-pointer-events-none')) {
          var rootO = collectionRoot(ov);
          if (rootO) closeDrawer(rootO);
        }
        return;
      }
      var viewBtn = t.closest && t.closest('.tw-collection-toolbar__views [data-tw-view]');
      if (viewBtn) {
        e.preventDefault();
        var rootV = collectionRoot(viewBtn);
        if (!rootV || rootV.getAttribute('data-enable-view-toggle') !== 'true') return;
        var v = viewBtn.getAttribute('data-tw-view');
        var mode = v === 'list' ? 'list' : v.replace(/^grid-/, '');
        twApplyCollectionView(rootV, mode);
      }
    });

    document.addEventListener('change', function(e) {
      var sel = e.target;
      if (!sel.matches || !sel.matches('select[name="sort_by"]')) return;
      var form = sel.closest('.tw-main-collection__sort-form');
      if (form) form.submit();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-tw-collection-root]').forEach(function(root) {
        var overlay = root.querySelector('[data-tw-sidebar-overlay]');
        if (overlay && !overlay.classList.contains('tw-pointer-events-none')) closeDrawer(root);
      });
    });

    var drawerResizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(drawerResizeTimer);
      drawerResizeTimer = setTimeout(function() {
        document.querySelectorAll('[data-tw-collection-root]').forEach(function(root) {
          var overlay = root.querySelector('[data-tw-sidebar-overlay]');
          if (overlay && !overlay.classList.contains('tw-pointer-events-none')) closeDrawer(root);
        });
        syncBodyScroll();
      }, 150);
    });

    function restoreCollectionViews() {
      document.querySelectorAll('[data-tw-collection-root][data-enable-view-toggle="true"]').forEach(function(root) {
        var sectionId = root.getAttribute('data-section-id');
        var storageKey = 'tw-collection-view-' + sectionId;
        var saved = null;
        try {
          saved = sessionStorage.getItem(storageKey);
        } catch (err) {}
        var mode = twNormalizeCollectionView(saved, root);
        if (mode == null) return;
        twApplyCollectionView(root, mode);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', restoreCollectionViews);
    } else {
      restoreCollectionViews();
    }
    document.addEventListener('shopify:section:load', restoreCollectionViews);

    // Cargar más / Scroll infinito
    (function() {
      document.querySelectorAll('[data-tw-collection-root]').forEach(function(root) {
        var paginationType = root.getAttribute('data-pagination-type') || 'pagination';
        var loadMoreWrap = root.querySelector('[data-tw-pagination-load-more]');
        var infiniteWrap = root.querySelector('[data-tw-pagination-infinite]');
        var loadMoreBtn = loadMoreWrap ? loadMoreWrap.querySelector('[data-load-more-btn]') : null;
        var grid = root.querySelector('.tw-main-collection__grid');
        var paginationEl = loadMoreWrap || infiniteWrap;
        var paginatePages = parseInt(paginationEl ? paginationEl.getAttribute('data-page-count') : '1', 10);

        if (!isFinite(paginatePages) || paginatePages < 1) paginatePages = 1;

        function currentPageFromUrl() {
          try {
            var page = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
            return isFinite(page) && page > 0 ? page : 1;
          } catch (err) {
            return 1;
          }
        }

        function gridFromHtml(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = root.id ? doc.getElementById(root.id) : null;
          return freshRoot ? freshRoot.querySelector('.tw-main-collection__grid') : doc.querySelector('.tw-main-collection__grid');
        }

        if (paginationType === 'load_more' && loadMoreBtn && grid) {
          loadMoreBtn.addEventListener('click', function() {
            var currentPage = parseInt(this.dataset.page || currentPageFromUrl(), 10);
            var nextPage = currentPage + 1;
            var url = new URL(window.location.href);
            url.searchParams.set('page', nextPage);
            this.textContent = 'Cargando...';
            this.disabled = true;
            fetch(url.pathname + url.search)
              .then(function(r) { return r.text(); })
              .then(function(html) {
                var newGrid = gridFromHtml(html);
                var newItems = newGrid ? newGrid.innerHTML : '';
                if (newItems) {
                  grid.insertAdjacentHTML('beforeend', newItems);
                  loadMoreBtn.dataset.page = nextPage;
                  loadMoreBtn.textContent = 'Cargar más';
                  loadMoreBtn.disabled = false;
                  if (nextPage >= paginatePages) {
                    loadMoreBtn.style.display = 'none';
                  }
                }
              })
              .catch(function() {
                loadMoreBtn.textContent = 'Error. Intenta de nuevo.';
                loadMoreBtn.disabled = false;
              });
          });
        }

        if (paginationType === 'infinite' && infiniteWrap && grid) {
          var loader = infiniteWrap.querySelector('.tw-infinite-scroll-loader');
          var loaded = false;
          var currentPage = currentPageFromUrl();
          window.addEventListener('scroll', function() {
            if (!loader || loaded || currentPage >= paginatePages) return;
            var rect = infiniteWrap.getBoundingClientRect();
            if (rect.top < window.innerHeight + 200) {
              loaded = true;
              loader.classList.remove('tw-hidden');
              loader.classList.add('tw-flex');
              var nextPage = currentPage + 1;
              var url = new URL(window.location.href);
              url.searchParams.set('page', nextPage);
              fetch(url.pathname + url.search)
                .then(function(r) { return r.text(); })
                .then(function(html) {
                  var newGrid = gridFromHtml(html);
                  var newItems = newGrid ? newGrid.innerHTML : '';
                  if (newItems) {
                    grid.insertAdjacentHTML('beforeend', newItems);
                    currentPage = nextPage;
                    loaded = false;
                    if (currentPage >= paginatePages) {
                      loader.textContent = 'No hay más productos';
                    } else {
                      loader.classList.add('tw-hidden');
                      loader.classList.remove('tw-flex');
                    }
                  }
                })
                .catch(function() {
                  loaded = false;
                });
            }
          });
        }
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('section[id^="tw-main-product-"]');
    if (!sections.length) { console.log('[TW Sticky] No tw-main-product section found'); return; }
    sections.forEach(function(sectionEl) {
      var sectionId = sectionEl.getAttribute('data-section-id') || sectionEl.id.replace('tw-main-product-', '');
      if (!sectionId) return;
      var form = document.getElementById('product-form-' + sectionId);
      if (!form) return;
    const productJson = sectionEl.querySelector('[data-product-json]');
    const variantPricesJson = sectionEl.querySelector('[data-variant-prices]');
    const product = productJson ? JSON.parse(productJson.textContent) : null;
    const variantPrices = variantPricesJson ? JSON.parse(variantPricesJson.textContent) : {};
    if (!product) return;

    const hiddenId = form.querySelector('input[name="id"]');
    const priceEl = document.getElementById('price-' + sectionId);
    const submitBtn = sectionEl.querySelector('.tw-pdp-buy-buttons__add') || sectionEl.querySelector('button[type="submit"][name="add"]');
    const addToCartLabel = submitBtn && submitBtn.getAttribute('data-add-to-cart');
    const soldOutLabel = submitBtn && submitBtn.getAttribute('data-sold-out');
    const variantOptions = sectionEl.querySelectorAll('.tw-variant-option');

    function getSelectedOptions() {
      const byPosition = {};
      variantOptions.forEach(function(el) {
        const pos = parseInt(el.getAttribute('data-option-position'), 10) || 0;
        if (!byPosition[pos]) byPosition[pos] = [];
        byPosition[pos].push(el);
      });
      const positions = Object.keys(byPosition).map(Number).sort(function(a, b) { return a - b; });
      const opts = [];
      positions.forEach(function(pos) {
        const els = byPosition[pos];
        let val = null;
        els.forEach(function(el) {
          if (el.tagName === 'SELECT') val = el.value || null;
          else if (el.checked) val = el.value || null;
        });
        opts.push(val);
      });
      return opts;
    }

    function findVariant(opts) {
      for (let i = 0; i < product.variants.length; i++) {
        const v = product.variants[i];
        if (v.option1 === (opts[0] || null) && v.option2 === (opts[1] || null) && v.option3 === (opts[2] || null)) {
          return v;
        }
      }
      return null;
    }

    function forceGallerySlide(index) {
      const gallery = document.querySelector('#tw-gallery-' + sectionId);
      if (!gallery) return;
      
      if (typeof gallery.goToSlide === 'function') {
        gallery.goToSlide(index);
        return;
      }

      // Brute force manual slide change
      const slides = gallery.querySelectorAll('.tw-gallery__slide');
      const thumbs = gallery.querySelectorAll('.tw-gallery__thumb');
      if (slides.length > index) {
        slides.forEach((slide, i) => {
          slide.classList.toggle('tw-gallery__slide--active', i === index);
          slide.classList.toggle('tw-translate-x-full', i !== index);
          slide.classList.toggle('tw-opacity-0', i !== index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        if (thumbs.length > index) {
          thumbs.forEach((thumb, i) => {
            const isActive = i === index;
            thumb.classList.toggle('tw-border-gray-900', isActive);
            thumb.classList.toggle('tw-border-transparent', !isActive);
            thumb.setAttribute('data-active', isActive ? 'true' : 'false');
            if (isActive) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          });
        }
      }
    }

    function updateForm(variant) {
      if (!variant) return;
      hiddenId.value = variant.id;

      const instBlocks = sectionEl.querySelectorAll('.tw-pdp-installments');
      instBlocks.forEach(function(instBlock) {
        const useAuto = instBlock.getAttribute('data-use-auto') === 'true';
        if (!useAuto) return; // Skip manual blocks

        const threshold = parseInt(instBlock.getAttribute('data-threshold'), 10) || 0;
        const count = parseInt(instBlock.getAttribute('data-installments'), 10) || 1;
        const format = instBlock.getAttribute('data-format') || '[price]';
        const price = variant.price;

        if (price >= threshold) {
          instBlock.style.display = '';
          const instPrice = Math.round(price / count);
          const formattedPrice = variantPrices[variant.id] ? variantPrices[variant.id].price : '';
          const symbol = formattedPrice.replace(/[0-9\u00a0\s.,]/g, '').trim();
          const value = (instPrice / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          const finalStr = format.replace('[price]', (symbol ? symbol + ' ' : '') + value);
          const textEl = instBlock.querySelector('.tw-pdp-installments__text');
          if (textEl) textEl.textContent = finalStr;
        } else {
          instBlock.style.display = 'none';
        }
      });


      if (variant.featured_media && variant.featured_media.position) {
        forceGallerySlide(variant.featured_media.position - 1);
      }
      if (priceEl && variantPrices[variant.id]) {
        const prices = variantPrices[variant.id];
        const priceSpan = priceEl.querySelector('.tw-product-price');
        if (priceSpan) priceSpan.textContent = prices.price;
        const compare = priceEl.querySelector('.tw-line-through');
        if (compare) {
          if (variant.compare_at_price > variant.price && prices.compare_at_price) {
            compare.textContent = prices.compare_at_price;
            compare.style.display = '';
          } else {
            compare.style.display = 'none';
          }
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? (addToCartLabel || 'Add to cart') : (soldOutLabel || 'Sold out');
      }
      sectionEl.querySelectorAll('.tw-pdp-buy-buttons__add').forEach(function(btn) {
        if (btn === submitBtn) return;
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? (btn.getAttribute('data-add-to-cart') || 'Add to cart') : (btn.getAttribute('data-sold-out') || 'Sold out');
      });
      const stickyPrice = sectionEl.querySelector('#tw-sticky-bar-price-' + sectionId);
      const stickyAdd = sectionEl.querySelector('#tw-sticky-bar-add-' + sectionId);
      const stickyVariantSelect = sectionEl.querySelector('.tw-sticky-bar-variant');
      if (stickyPrice && variantPrices[variant.id]) stickyPrice.textContent = variantPrices[variant.id].price;
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? (stickyAdd.getAttribute('data-add-to-cart') || 'Add to cart') : (stickyAdd.getAttribute('data-sold-out') || 'Sold out');
      }
      if (stickyVariantSelect) stickyVariantSelect.value = String(variant.id);
      var dynamicCheckout = sectionEl.querySelector('[data-dynamic-checkout-wrapper]');
      if (dynamicCheckout) dynamicCheckout.style.display = variant.available ? '' : 'none';
    }

    function syncStickyQuantityFromForm() {
      const mainQty = form.querySelector('input[name="quantity"]');
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (mainQty && stickyQty) stickyQty.value = mainQty.value;
    }
    function syncFormQuantityFromSticky() {
      const mainQty = form.querySelector('input[name="quantity"]');
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (mainQty && stickyQty) mainQty.value = stickyQty.value;
    }

    const triggerEl = sectionEl.querySelector('.tw-buy-buttons-trigger');
    const stickyBar = sectionEl.querySelector('.tw-sticky-add-cart');
    if (triggerEl && stickyBar) {
      syncStickyQuantityFromForm();
      const stickyVariantSelect = sectionEl.querySelector('.tw-sticky-bar-variant');
      if (stickyVariantSelect) {
        stickyVariantSelect.addEventListener('change', function() {
          const vid = parseInt(this.value, 10);
          const v = product.variants.find(function(x) { return x.id === vid; });
          if (v) updateForm(v);
        });
      }
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (stickyQty) {
        stickyQty.addEventListener('change', syncFormQuantityFromSticky);
        stickyQty.addEventListener('input', syncFormQuantityFromSticky);
        sectionEl.querySelectorAll('.tw-sticky-qty-minus, .tw-sticky-qty-plus').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var n = parseInt(stickyQty.value, 10) || 1;
            if (btn.classList.contains('tw-sticky-qty-minus')) n = Math.max(1, n - 1);
            else n = Math.min(99, n + 1);
            stickyQty.value = n;
            syncFormQuantityFromSticky();
          });
        });
      }
      const mainQtyInput = form.querySelector('input[name="quantity"]');
      if (mainQtyInput) {
        mainQtyInput.addEventListener('change', syncStickyQuantityFromForm);
        mainQtyInput.addEventListener('input', syncStickyQuantityFromForm);
      }
      form.addEventListener('click', function(e) {
        if (e.target.closest('[data-qty-minus], [data-qty-plus]')) setTimeout(syncStickyQuantityFromForm, 0);
      });

      let stickyVisible = false;
      const footerEl = document.querySelector('footer.tw-footer');
      var stickyBarHeight = 80;
      function onScroll() {
        const triggerRect = triggerEl.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        var footerNear = false;
        if (footerEl) {
          var footerRect = footerEl.getBoundingClientRect();
          footerNear = footerRect.top < viewportHeight - stickyBarHeight;
        }
        if (footerNear) {
          if (stickyVisible) { stickyBar.classList.remove('tw-translate-y-0'); stickyBar.classList.add('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'true'); stickyVisible = false; }
          return;
        }
        if (triggerRect.bottom <= 0) {
          if (!stickyVisible) { stickyBar.classList.add('tw-translate-y-0'); stickyBar.classList.remove('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'false'); stickyVisible = true; }
        } else {
          if (stickyVisible) { stickyBar.classList.remove('tw-translate-y-0'); stickyBar.classList.add('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'true'); stickyVisible = false; }
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      const stickyAddBtn = sectionEl.querySelector('.tw-sticky-bar-add');
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function() {
          if (form && !stickyAddBtn.disabled) form.requestSubmit();
        });
      }
    }

    variantOptions.forEach(function(el) {
      el.addEventListener('change', function() {
        const opts = getSelectedOptions();
        const variant = findVariant(opts);
        updateForm(variant);
      });
    });
    var currentVariantId = hiddenId && parseInt(hiddenId.value, 10);
    if (currentVariantId && product && product.variants) {
      var currentVariant = product.variants.find(function(v) { return v.id === currentVariantId; });
      if (currentVariant) updateForm(currentVariant);
    }
    }); // end sections.forEach
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-media-gallery-slide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-tw-mgs]');
    if (!section || !section.querySelector('[data-tw-mgs-list]')) return;
    var list = section.querySelector('[data-tw-mgs-list]');
    var slides = section.querySelectorAll('[data-tw-mgs-slide]');
    var total = slides.length;
    if (total <= 0) return;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    function goTo(i) {
      index = (i + total) % total;
      list.style.transform = 'translateX(-' + (index * 100) + '%)';
    }
    function next() { goTo(index + 1); }
    section.querySelector('[data-tw-mgs-prev]') && section.querySelector('[data-tw-mgs-prev]').addEventListener('click', function() { goTo(index - 1); if (timer) clearInterval(timer); if (autoplay) timer = setInterval(next, speed); });
    section.querySelector('[data-tw-mgs-next]') && section.querySelector('[data-tw-mgs-next]').addEventListener('click', function() { goTo(index + 1); if (timer) clearInterval(timer); if (autoplay) timer = setInterval(next, speed); });
    goTo(0);
    if (autoplay && total > 1) timer = setInterval(next, speed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-minicart-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function loadUpsells() {
      document.querySelectorAll('.tw-cart-upsell--fetch').forEach(function(el) {
        if (!el.dataset.url) return;
        if (el.dataset.loaded) return;
        var grid = el.querySelector('.tw-cart-upsell__grid');
        if (!grid) return;
        el.dataset.loaded = 'true';
        fetch(el.dataset.url)
          .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
          .then(function(html) {
            var wrap = document.createElement('div');
            wrap.innerHTML = html;
            var sectionId = (el.dataset.sectionId || 'tw-cart-upsell').replace(/\W/g, '-');
            var sectionEl = wrap.querySelector('#shopify-section-' + sectionId + ' .tw-cart-upsell__grid');
            if (!sectionEl && wrap.querySelector('.tw-cart-upsell__grid')) sectionEl = wrap.querySelector('.tw-cart-upsell__grid');
            if (sectionEl && sectionEl.innerHTML.trim()) {
              grid.innerHTML = sectionEl.innerHTML;
              grid.classList.remove('tw-cart-upsell__grid--placeholder');
            } else {
              el.style.display = 'none';
            }
          })
          .catch(function() { el.style.display = 'none'; });
      });
    }
    
    loadUpsells();
    
    document.addEventListener('cart:drawer-open', loadUpsells);
    var cartDrawer = document.querySelector('[data-drawer]');
    if (cartDrawer) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open' || mutation.attributeName === 'class') {
            var isOpen = cartDrawer.hasAttribute('open') || cartDrawer.classList.contains('open') || cartDrawer.classList.contains('is-open');
            if (isOpen) loadUpsells();
          }
        });
      });
      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['open', 'class'] });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-pickup-availability"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-tw-pickup-drawer]') && document.querySelector('[data-tw-pickup-drawer]').closest('.tw-pickup-availability');
    if (!section) return;
    const trigger = section.querySelector('[data-tw-pickup-trigger]');
    const drawer = section.querySelector('[data-tw-pickup-drawer]');
    const closeBtns = section.querySelectorAll('[data-tw-pickup-close]');
    function open() {
      if (drawer) drawer.classList.remove('tw-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (drawer) drawer.classList.add('tw-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (trigger) trigger.addEventListener('click', open);
    closeBtns.forEach(function(btn) { btn.addEventListener('click', close); });
    if (drawer) drawer.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-slideshow-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var wrap = document.querySelector('[data-tw-sb]');
    if (!wrap || !wrap.querySelector('[data-tw-sb-list]')) return;
    var list = wrap.querySelector('[data-tw-sb-list]');
    var slides = wrap.querySelectorAll('[data-tw-sb-slide]');
    var n = slides.length;
    if (n <= 0) return;
    var idx = 0;
    var autoplay = wrap.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(wrap.getAttribute('data-speed'), 10) || 5000;
    var t = null;
    function go(i) {
      idx = (i + n) % n;
      list.style.transform = 'translateX(-' + (idx * 100) + '%)';
    }
    function next() { go(idx + 1); }
    if (wrap.querySelector('[data-tw-sb-prev]')) wrap.querySelector('[data-tw-sb-prev]').addEventListener('click', function() { go(idx - 1); if (t) clearInterval(t); if (autoplay) t = setInterval(next, speed); });
    if (wrap.querySelector('[data-tw-sb-next]')) wrap.querySelector('[data-tw-sb-next]').addEventListener('click', function() { go(idx + 1); if (t) clearInterval(t); if (autoplay) t = setInterval(next, speed); });
    go(0);
    if (autoplay && n > 1) t = setInterval(next, speed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-tw-slideshow]');
    if (!section || !section.querySelector('[data-tw-slideshow-list]')) return;
    var list = section.querySelector('[data-tw-slideshow-list]');
    var slides = section.querySelectorAll('[data-tw-slide]');
    var total = slides.length;
    if (total <= 0) return;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    function goTo(i) {
      index = (i + total) % total;
      list.style.transform = 'translateX(-' + (index * 100) + '%)';
      section.querySelectorAll('[data-tw-dot]').forEach(function(btn, j) {
        btn.setAttribute('aria-current', j === index ? 'slide' : null);
      });
    }
    function next() { goTo(index + 1); }
    function startAutoplay() {
      if (timer) clearInterval(timer);
      if (autoplay && total > 1) timer = setInterval(next, speed);
    }
    section.querySelector('[data-tw-slide-prev]') && section.querySelector('[data-tw-slide-prev]').addEventListener('click', function() { goTo(index - 1); startAutoplay(); });
    section.querySelector('[data-tw-slide-next]') && section.querySelector('[data-tw-slide-next]').addEventListener('click', function() { goTo(index + 1); startAutoplay(); });
    section.querySelectorAll('[data-tw-dot]').forEach(function(btn, i) {
      btn.addEventListener('click', function() { goTo(i); startAutoplay(); });
    });
    goTo(0);
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();
})();
